// extracted by mini-css-extract-plugin
module.exports = {"quickBooking":"QuickBooking_quickBooking__14XJC"};